import { ADMIN_DASHBAORD_FAILURE, ADMIN_DASHBAORD_SUCCESS } from "../../constants/index";
import { onSuccess, onFailure } from "../common";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initStat, action) => {
  switch (action.type) {
    case ADMIN_DASHBAORD_SUCCESS:
      return onSuccess(state, action);
    case ADMIN_DASHBAORD_FAILURE:
      return onFailure(state, action);
    default:
      return { ...state };
  }
};
